import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import HotelSearchBar from '../components/HotelSearchBar';
import DefaultSEO from '../components/DefaultSEO';
import { offerService } from '../services/offerService';
import { Loader2 } from 'lucide-react';

const OffersPage = () => {
    const navigate = useNavigate();
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);

    const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/api/v1';
    const storageBase = apiBase.replace(/\/api\/v1\/?$/, '') + '/storage';

    useEffect(() => {
        const fetchOffers = async () => {
            try {
                const data = await offerService.getOffers();
                // Coupons are paginated in response.data.data.data
                setOffers(data.data.data || []);
            } catch (err) {
                console.error('Error fetching offers:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchOffers();
    }, []);

    if (loading) {
        return (
            <div className="container py-5 d-flex justify-content-center align-items-center min-vh-100">
                <Loader2 className="animate-spin text-primary" size={48} />
            </div>
        );
    }

    return (
        <>
            <DefaultSEO title="Special Offers & Deals | ZoyoTrip" description="Discover exclusive discounts and special offers on hotel bookings with ZoyoTrip." />
            <div className='pb-5'>
                <div className="container py-5 offers-container">
                    <div className="text-center mb-4 mb-md-5">
                        <h2 className="fw-bold text-primary">🎁 Exclusive Offers Just for You</h2>
                        <p className="text-muted mb-0">Save big on your next stay with ZoyoTrip</p>
                    </div>

                    <div className="row g-4">
                        {offers.length > 0 ? offers.map((offer) => (
                            <div key={offer.id} className="col-12 col-md-6 col-lg-4">
                                <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden offer-card">
                                    {/* Image Wrapper */}
                                    <div className="position-relative" style={{ height: '220px' }}>
                                        <img
                                            src={offer.image ? `${storageBase}/${offer.image}` : "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='250' viewBox='0 0 400 250'><rect width='100%' height='100%' fill='%23e5e7eb'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='28' font-weight='bold' fill='%239ca3af'>Offer</text></svg>"}
                                            alt={offer.title}
                                            className="w-100 h-100 object-fit-cover"
                                        />

                                        {/* Discount Badge */}
                                        {offer.discount_value && (
                                            <div className="position-absolute top-0 start-0 m-3">
                                                <span className="badge bg-danger rounded-pill px-3 py-2 shadow-sm fs-6">
                                                    {offer.discount_type === 'percentage' ? `${parseFloat(offer.discount_value)}%` : `₹${parseFloat(offer.discount_value)}`} OFF
                                                </span>
                                            </div>
                                        )}
                                    </div>

                                    {/* Card Content */}
                                    <div className="card-body d-flex flex-column p-4">
                                        <h5 className="card-title fw-bold text-dark mb-3 text-truncate" title={offer.title}>
                                            {offer.title}
                                        </h5>

                                        <div className="mb-4 d-flex align-items-center bg-light p-2 rounded-3">
                                            <span className="text-muted small me-2"><i className="bi bi-tag-fill me-1 text-primary"></i>Code:</span>
                                            <span className="badge bg-white text-primary border border-primary px-3 py-1 font-monospace fs-6 fw-bold shadow-sm">
                                                {offer.code?.toUpperCase()}
                                            </span>
                                        </div>

                                        <button
                                            onClick={() => navigate(`/offers/${offer.id}`)}
                                            className="btn btn-primary fw-semibold rounded-pill mt-auto w-100 py-2 d-flex justify-content-center align-items-center gap-2"
                                        >
                                            View Details <i className="bi bi-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )) : (
                            <div className="col-12 text-center py-5">
                                <div className="bg-light rounded-4 p-5">
                                    <i className="bi bi-ticket-perforated fs-1 text-muted mb-3 d-block"></i>
                                    <h4 className="fw-bold text-dark">No active offers at the moment</h4>
                                    <p className="text-muted mb-0">Check back soon for amazing deals and discounts!</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="container my-5 d-none d-md-flex">
                    <HotelSearchBar />
                </div>
            </div>

            <style jsx>{`
                .animate-spin { animation: spin 1s linear infinite; }
                @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                .offer-card { transition: transform 0.3s ease; }
                .offer-card:hover { transform: translateY(-5px); }
                .hide-scrollbar::-webkit-scrollbar { display: none; }
                .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
            `}</style>
        </>
    )
}

export default OffersPage
